export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'defaultImageUrl',
    width: 70,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' }
  },
  {
    title: that.$l('INDEX.table_label_channel_salesTitle') || '渠道售卖标题',
    field: 'salesTitle',
    minWidth: 450,
    fixed: 'left',
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    className: 'align-top',
    slots: { default: 'displaySalesTitle' }
  },
  {
    title: that.$l('INDEX.table_label_channel_name') || '渠道名称',
    field: 'platformName',
    minWidth: 180,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayPlatform' }
  },
  {
    title: that.$l('INDEX.table_label_firstOnShelvesDate') || '首次上架日期',
    field: 'firstOnShelvesDate',
    minWidth: 120,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_salesPrice') || '售卖价格',
    field: 'v_salesPrice',
    minWidth: 140,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_operate') || '运营人员',
    field: 'operateName',
    minWidth: 150,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true
  }
]
